
const imageReducer = (state = {zoom:1, rotate:0}, action) => {

    switch(action.type){
        case "setZoom":
            return{
                ...state, zoom:action.payload
            }
        case "setRotate":
            return{
                ...state, rotate:action.payload
            }
        default:
            return state
    }
}

export default imageReducer